import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import BuyPop from '../Pop/BuyPop/BuyPop.vue';
export default {
  components: {
    BuyPop: BuyPop
  },
  data: function data() {
    return {
      showPop: false,
      buyParams: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['hasTicket'])), mapGetters(['mySupportCount'])), {}, {
    isShowXiaoe: function isShowXiaoe() {
      var _ref = this.setting || {},
          _ref$ = _ref.小鹅花钱;

      _ref$ = _ref$ === void 0 ? {} : _ref$;
      var 背景图 = _ref$.背景图,
          跳转链接 = _ref$.跳转链接;
      return !!(背景图 && 跳转链接);
    }
  }),
  methods: {
    showPayPop: function showPayPop() {
      var vm = this;

      if (!this.loginService.isLogin) {
        this.loginService.openLogin();
        return;
      }

      if (!this.vipService.isVip) {
        this.confirm({
          title: '开通会员享优惠',
          msg: '您还不是会员，开通会员后每份影票最多可省12元/份。',
          cancelText: '以原价购买',
          confirmText: '立即前往',
          cancel: function cancel() {
            vm.showPop = true;
            vm.$report.click(vm.reportData.开通弹框.原价购买);
          },
          confirm: function confirm() {
            vm.openVip();
            vm.$report.click(vm.reportData.开通弹框.开通会员);
          }
        });
        vm.$report.expose(this.reportData.开通弹框.开通弹框);
        vm.$report.expose(this.reportData.开通弹框.原价购买);
        vm.$report.expose(this.reportData.开通弹框.开通会员);
        return;
      }

      vm.showPop = true;
    },
    share: function share() {
      var otherCount = this.mySupportCount();
      this.eventBus.$emit('launchShare', {
        mode: 'xy',
        label: "\u5DF2\u652F\u6301".concat(otherCount + (this.hasTicket ? 1 : 0), "\u4EFD")
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.eventBus.$on('showPayPop', function (params) {
      _this.buyParams = params;

      _this.showPayPop();
    });
  }
};